module.exports = __webpack_public_path__ + "static/media/comp-granulating-s.c26a5f07.jpg";